




















































import { defineComponent, PropType, computed, useContext, ref } from '@nuxtjs/composition-api';
import dayjs from 'dayjs';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { SMARTPHONE } from '~/constants';
import { THUMBNAIL_300, THUMBNAIL_400 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import { formatCategory } from '~/utils/event';
import { EventSchema } from '~/types/api/event-utils';
import { SeatsLeft } from '~/enums';

export default defineComponent({
  components: {
    AppIcon,
    AppImage,
    AppLink,
  },
  props: {
    shopName: {
      type: String,
      required: true,
    },
    event: {
      type: Object as PropType<EventSchema<'FrontEventSummary'>>,
      required: true,
    },
    tags: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props) {
    const { app } = useContext();
    const isSmartPhone = ref(app.$ua.deviceType() === SMARTPHONE);

    /** イベント開催月日をフォーマット */
    const formatEventDate = (eventDate: string, hasDetail: boolean) => {
      if (hasDetail) {
        return dayjs(eventDate).format('YYYY年MM月DD日 (dd)');
      } else {
        return dayjs(eventDate).format('MM/DD');
      }
    };

    /** イベントが中止か否か */
    const isCanceled = computed(() => {
      return props.event.status === 'CANCELED';
    });

    /** イベントが1日のみか */
    const isOneDay = computed(() => {
      return props.event.startDate === props.event.endDate;
    });

    return {
      formatEventDate,
      formatCategory,
      url,
      isCanceled,
      isOneDay,
      SeatsLeft,
      isSmartPhone,
      THUMBNAIL_300,
      THUMBNAIL_400,
    };
  },
});
